import axios from "axios";
import API_BASE from "./config";

// Plain axios client — the standalone calculator is public, so there's no auth
// token to attach.
const api = axios.create({
  baseURL: API_BASE,
});

export default api;
